import moment from "moment";
import createManagementShortDateMethods from "@shared/createManagementShortDateMethods.cjs";

export default createManagementShortDateMethods({ DateFormatter: moment });
